'use client'
import styles from './VisaTypes.module.css'
import { useTranslations } from 'next-intl'
import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

function FadeIn({ children, className }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null)
  const inView = useInView(ref, { once: false, margin: '-80px' })

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 24 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  )
}

export default function VisaTypes() {
  const t = useTranslations('VisaGuidePage.visaTypes')
  const tRenewal = useTranslations('VisaGuidePage.renewalTabs.visaRenewal')

  const DOC_KEYS = ['1', '2', '3', '4', '5', '6', '7'] as const

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        

        {/* Fees Table */}
        <FadeIn className={styles.feesBlock}>
          <h2 className={styles.title}>{t('title')}</h2>
          <h3 className={styles.feesTitle}>{tRenewal('feesTitle')}</h3>
          <p className={styles.feesIntro}>{tRenewal('feesIntro')}</p>
          <div className={styles.tableWrapper}>
            <table className={styles.feesTable}>
              <thead>
                <tr>
                  <th>{tRenewal('feesTable.header.item')}</th>
                  <th>{tRenewal('feesTable.header.cost')}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{tRenewal('feesTable.rows.firstYear.item')}</td>
                  <td>{tRenewal('feesTable.rows.firstYear.cost')}</td>
                </tr>
                <tr>
                  <td>{tRenewal('feesTable.rows.renewal.item')}</td>
                  <td>{tRenewal('feesTable.rows.renewal.cost')}</td>
                </tr>
                <tr>
                  <td>{tRenewal('feesTable.rows.insurance.item')}</td>
                  <td>{tRenewal('feesTable.rows.insurance.cost')}</td>
                </tr>
                <tr>
                  <td>{tRenewal('feesTable.rows.bond.item')}</td>
                  <td>{tRenewal('feesTable.rows.bond.cost')}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className={styles.tableNote}>{tRenewal('feesTable.note')}</p>
        </FadeIn>

      </div>
    </section>
  )
}